export const manualEmailSendFeedback = response => {
	const queued = response?.queuedCount || 0
	const delayed = response?.delayedLocationCount || 0
	const corrected = response?.correctedCount || 0
	const notificationFailed = response?.notification?.status === 'failed'
	let title = 'Reports Already Covered'
	let content = 'No new report emails were queued. Reports for this date are already sent or awaiting delivery.'

	if (response?.waitingForAll) {
		title = 'Waiting For All Locations'
		content = 'Your choice is saved. Unsent reports will be queued when all remaining locations have complete VGT data. The system checks every five minutes.'
	} else if (response?.deliveryPolicy === 'ready_cancel') {
		title = 'Ready Reports Queued; Remaining Cancelled'
		content = `${queued} new report email(s) were queued. ${response?.cancelledLocationCount || 0} pending location(s) are cancelled for ${response?.reportDate}.`
	} else if (delayed > 0) {
		title = 'Reports Waiting For VGT Data'
		content = `${delayed} location(s) are awaiting complete VGT data. The system checks every five minutes and sends each delayed report when its data is verified.`
		if (queued > 0) content += ` ${queued} report email(s) with verified data were queued for delivery.`
	} else if (queued > 0) {
		title = corrected > 0 ? 'Updated Reports Queued' : 'Report Emails Queued'
		content = `${queued} report email(s) were queued for delivery.`
		if (corrected > 0) content += ` ${corrected} replace earlier reports with incomplete data.`
	}

	if (response?.delayNoticeCount > 0) content += ' Delay notices were also queued for owners and administrators.'
	if (response?.notification?.requested && !notificationFailed) content += ' An admin notification was queued separately.'
	if (notificationFailed) content += ' The admin notification could not be queued. Please retry the notification.'

	return { intent: notificationFailed ? 'error' : 'success', title, content }
}
